import React, { useEffect, useState } from "react";
import Swal from "../../utils/swal";
import { showSuccessToast, showErrorToast } from "../../utils/swalToast";
import apiClient from "../../utils/apiClient";
import { useUser } from "../../pages/UserContext";
import RowActionsMenu from "../custom/RowActionsMenu";
import CustomButton from "../custom/CustomButton";
import CustomDataGrid from "../custom/CustomDataGrid";
import EditPengajaranModal from "./EditPengajaranModal";
import InsertPengajaranModal from "./InsertPengajaranModal";

export default function InstructData() {
  const userDetails = useUser();
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const [openInsertModal, setOpenInsertModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editTarget, setEditTarget] = useState({ userId: null, instructId: null });

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = `/instruct?isDeleted=0`;
        if (userDetails.role !== "admin") {
          url += `&lecturerId=${userDetails.uuid}`;
        }
        const response = await apiClient.get(url);
        setRows(
          response.data.data.map((instruct, index) => ({
            no: index + 1 + (page - 1) * 10,
            id: instruct.id,
            idDosen: instruct.id_dosen,
            namaAnggota: instruct.lecturer_name,
            mataKuliah: instruct.mata_kuliah,
          }))
        );
      } catch (error) {
        console.error("Error fetching instruct", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [page, refresh, userDetails.role, userDetails.uuid]);

  const handleAddInstruct = () => {
    setOpenInsertModal(true);
  };

  const handleInsertSuccess = () => {
    setOpenInsertModal(false);
    setRefresh((prev) => !prev);
  };

  const handleEditInstruct = (userId, instructId) => {
    setEditTarget({ userId, instructId });
    setOpenEditModal(true);
  };

  const handleEditSuccess = () => {
    setOpenEditModal(false);
    setRefresh((prev) => !prev);
  };

  const handleDeleteInstruct = async (instructId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete this data pengajaran",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await apiClient.post(`/instruct/delete`, { id: instructId });
          showSuccessToast("Data pengajaran is successfully deleted.");
          setRefresh(!refresh);
        } catch (error) {
          showErrorToast("There was an error deleting data pengajaran.");
        }
      }
    });
  };

  // Conditionally add delete action column if user is admin
  const columns = [
    { field: "no", headerName: "No.", flex: 1 },
    { field: "namaAnggota", headerName: "Nama Anggota", flex: 1 },
    { field: "mataKuliah", headerName: "Mata Kuliah", flex: 1 },
    {
      field: "actions",
      headerName: "Action",
      renderCell: (params) => (
        <RowActionsMenu
          actions={[
            {
              label: "Edit",
              onClick: () => handleEditInstruct(params.row.idDosen, params.row.id),
            },
            {
              label: "Hapus",
              onClick: () => handleDeleteInstruct(params.row.id),
              danger: true,
            },
          ]}
        />
      ),
      flex: 1,
    },
  ];

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <CustomButton
        onClick={handleAddInstruct}
        text="Tambah Pengajaran"
        isFullWidth={false}
        baseColor="#003158"
        hoverColor="#00213A"
      />
      <br></br>
      <CustomDataGrid
        rows={rows}
        columns={columns}
        setPage={setPage}
        loading={loading}
      />
      <EditPengajaranModal
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        userId={editTarget.userId}
        instructId={editTarget.instructId}
        onSuccess={handleEditSuccess}
      />
      <InsertPengajaranModal
        open={openInsertModal}
        onClose={() => setOpenInsertModal(false)}
        onSuccess={handleInsertSuccess}
      />
    </div>
  );
}
